import React from "react";
import { useSelector } from "react-redux";

const UserAccount = () => {
    const { logout, user } = useSelector(({ user }) => {
        return user;
    });

    return (
        <div>
            <header>
                <h2>User account</h2>
                <div className="logout-container">
                    <button className="btn-type-3 logout-btn" onClick={logout}>
                        Logout
                    </button>
                    <span>{user.displayName ? user.displayName : user?.email }</span> 
                </div>
            </header>
            <section>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Tempora a hic libero possimus sint. Facere laboriosam, adipisci
                blanditiis, quas, maxime corrupti fuga doloribus accusantium
                officiis totam neque velit voluptatibus corporis?
            </section>
        </div>
    );
};

export default UserAccount;
